import React from "react";

import { myGlobals, myUtilities } from "../../Utils";
import TrifectaCover from "./TrifectaCover";
import * as DOMPurify from 'dompurify';
class ErrorComponentLinkExpired extends React.Component {
    onClick = () => {
      window.location = myGlobals.initialLink;
    };
    showBackButton = () => {
      if (this.props.isTopBuild) {
        return (
          <button className="error-back-button" onClick={this.onClick}>
            {myUtilities.accountSpecificLanguage('Error.Button.GoBack', 'Go Back')}
          </button>
        );
      }
    };
    renderLinkExpired = () => {
        return <div className="centered-container">
          {this.props.errorMessage}
          <br />
          {this.showBackButton()}
        </div>;
      };
   render() {
    return myGlobals.currentTheme === "trifectaTheme.css" ? (
    	      <TrifectaCover> {this.renderLinkExpired()} </TrifectaCover>
    	    ) : (
    	      this.renderLinkExpired()
    	    );
    }
  }
  export default ErrorComponentLinkExpired;